function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22 22",
    width: "22px",
    height: "22px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface224684823"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11 1.320312 C 5.652344 1.320312 1.320312 5.652344 1.320312 11 C 1.320312 15.851562 4.894531 19.859375 9.554688 20.558594 L 9.554688 13.566406 L 7.160156 13.566406 L 7.160156 11.019531 L 9.554688 11.019531 L 9.554688 9.328125 C 9.554688 6.523438 10.917969 5.292969 13.25 5.292969 C 14.363281 5.292969 14.953125 5.375 15.234375 5.414062 L 15.234375 7.636719 L 13.644531 7.636719 C 12.65625 7.636719 12.308594 8.574219 12.308594 9.628906 L 12.308594 11.019531 L 15.210938 11.019531 L 14.816406 13.566406 L 12.308594 13.566406 L 12.308594 20.582031 C 17.035156 19.941406 20.679688 15.898438 20.679688 11 C 20.679688 5.652344 16.347656 1.320312 11 1.320312 Z M 11 1.320312 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bd1fe8351cc0b3d325f161138f835aeb.svg";
export { ForwardRef as ReactComponent };